var deepMerge = require('./deep-merge');
var Events = require('./events');

var Panes = function(el, options) {
    this.$el = el instanceof jQuery ? el : $(el);
    this.options = deepMerge({
        parentClass: 'panes',
        childClass: 'pane',
        nextClass: 'pane-next',
        previousClass: 'pane-previous'
    }, options || {});
    this.init();
};

Panes.prototype = {
    constructor: Panes,
    $el: undefined,
    events: undefined,
    init: function() {
        var self = this;

        if (!self.$el.length) {
            return;
        }

        // set current pane
        self.setActive(0);

        // controls
        $('.' + self.options.previousClass).on('click', function() { self.previousPane(); });
        $('.' + self.options.nextClass).on('click', function() { self.nextPane(); });
    },
    setActive: function(index) {
        var self = this,
            panes = self.$el.find('.' + self.options.childClass);
        if (panes.length > index) {
            panes.removeClass('active');
            $(panes[index]).addClass('active');
        }
    },
    nextPane: function() {
        var self = this,
            panes = self.$el.find('.' + self.options.childClass),
            current = self.getCurrent();
        if (current !== null) {
            var next = current + 1;
            if (panes.length > next) {
                self.setActive(next);
            }
            else {
                self.setActive(0);
            }
        }
    },
    previousPane: function() {
        var self = this,
            panes = self.$el.find('.' + self.options.childClass),
            current = self.getCurrent();
        if (current !== null) {
            var previous = current - 1;
            if (previous > -1) {
                self.setActive(previous);
            }
            else {
                self.setActive(panes.length - 1);
            }
        }
    },
    getCurrent: function() {
        var self = this,
            panes = self.$el.find('.' + self.options.childClass),
            index = 0,
            found = false;
        if (!self.$el.find('.' + self.options.childClass + '.active').length) {
            return null;
        }
        panes.each(function() {
            if (!found && !this.classList.contains('active')) {
                index++;
            }
            else {
                found = true;
            }
        });

        return found ? index : null;
    }
};

window.addEventListener('load', function() {
    if (window.location.href.match(/\/admin\/test\/?$/)) {
        var m = new Panes(document.querySelector('.panes'));
        console.log('panes loaded');
    }
});

module.exports = Panes;